import * as _ from 'lodash';
import { Reducer } from 'redux';
import { MenuItemActionType } from '../actions';
import { MenuItemType } from '../model/menuItems';
import { MenuItemAction } from '../actions/menuItemActions';

type ReducerState = MenuItemType | null;
type ReducerAction = MenuItemAction;

const initialState: ReducerState = MenuItemType.Wineries;

export const currentMenuItem: Reducer<ReducerState> = (state: ReducerState = initialState, action: ReducerAction): ReducerState => {
    if (_.endsWith(action.type, MenuItemActionType.Changed)) {
        return action.current;
    } else {
        return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/currentMenuItem.ts